/* eslint-disable no-new */
import Navigation from './modules/Navigation';
import ScrollButton from './modules/ScrollButton';
import LawyerSlider from './modules/LawyerSlider';
import JudgmentSlider from './modules/JudgmentSlider';
import JokesSlider from './modules/JokesSlider';
import ContactForm from './modules/ContactForm';
import LeafletMap from './modules/LeafletMap';
import 'svgxuse';
import 'mdn-polyfills/Element.prototype.closest';
import 'mdn-polyfills/NodeList.prototype.forEach';
import 'svg-classlist-polyfill';

new Navigation();
new ScrollButton();
new LawyerSlider();
new JudgmentSlider();
new JokesSlider();
new LeafletMap();
new ContactForm();

// eslint-disable-next-line
import style from '../scss/mustard.scss';
